export default __webpack_public_path__ + "static/media/pi.faa13e16.svg";